<script>
export default {
  props: {
    render: Function,
    row: Object,
  },

  render (h) {
    const { render } = this;
    const content = render();

    if (typeof content !== "number" && !content) {
      return (
        <div class="cell-content">
          <span class="no-content">N/A</span>
        </div>
      )
    }
    return (
      <div class="cell-content">
        {content}
      </div>
    )
  }
}
</script>